import {TAGNAME_BODY} from "@acng/frontend-bounty/dom/type.js";
import {body} from "@acng/frontend-bounty";

import {CTX_OBSERVE, CTX_SUBSCRIBE_TAGNAME} from "../minify.js";

/**
 * @template T
 *
 * @param {string} signature
 * [CSS selector](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_selectors)
 *
 * @param {import("../model/context-interface").Context<T>} context
 *
 * @returns {<X, E extends Element>(element: E, handler: (element: E, value: T, previous?: T) => X) => X}
 */
export function Watch(signature, context) {
  const symbol = Symbol();

  context[CTX_SUBSCRIBE_TAGNAME](signature, symbol);

  return (element, handler) =>
    context[CTX_OBSERVE](element, (value, previous) => handler(element, value, previous), symbol);
}

/**
 * @template T
 *
 * @param {import("../model/context-interface").Context<T>} context
 *
 * @returns {<X>(handler: (value: T, previous?: T) => X) => X}
 */
export function GlobalWatch(context) {
  const watch = Watch(TAGNAME_BODY, context);

  return (handler) => watch(body, (_, value, previous) => handler(value, previous));
}
